import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ variant = 'default', className = '', size = 'md' }) => {
  const heights = {
    sm: 'h-9',
    md: 'h-12',
    lg: 'h-16',
    xl: 'h-24'
  };

  return (
    <Link
      to="/"
      className={`inline-flex items-center group ${className}`}
      aria-label="Varni Visa - Home"
      data-testid="site-logo"
    >
      <img
        src="/logo.png"
        alt="Varni Visa - Global Travel Solutions"
        className={`${heights[size]} w-auto object-contain transition-transform group-hover:scale-105`}
      />
    </Link>
  );
};

export default Logo;
